import store from '@state/store'
import Echo from 'laravel-echo'

import Pusher from 'pusher-js'
window.Pusher = Pusher

const currentUser = store.state.auth.currentUser || {}
const currentUserId = currentUser.id || undefined
const currentUserToken = store.state.auth.token || undefined

export default function() {
  // check availability
  if (!('Notification' in window)) {
    return
  }

  // check app state
  if (!currentUserId || !currentUserToken) {
    return
  }

  window.Echo = new Echo({
    broadcaster: 'reverb',
    key: '4c1e7495e5727cede788aa9a731969843a7c29dd803edc21ea5b0f7d94d6a55d',
    wsHost: process.env.VUE_APP_BASE_URL.replace(/^https?:\/\//, ''),
    wsPort: '443',
    wssPort: '443',
    wsPath: '/ws',
    forceTLS: !0,
    enabledTransports: ['ws', 'wss'],
    auth: {
      headers: {
        Authorization: 'Bearer ' + currentUserToken,
      },
    },
  })

  Notification.requestPermission()

  // listening on private channel
  window.Echo.private(`App.Models.User.${currentUserId}`).notification(
    (notification) => {
      if (Notification.permission === 'granted') {
        let title = ''
        const body = notification.message
        if (notification.author !== undefined && notification.author !== false)
          title = notification.author.name
        const browserNotification = new Notification(title, {
          icon: `${window.location.origin}/android-chrome-192x192.png`,
          body: body,
        })
        browserNotification.onclick = function(e) {
          window.location.href = notification.link
        }
      }

      store.dispatch('auth/getNotifications')
    }
  )
}
